import type { FareRule } from '../../schema/row-types.ts';
import type {
  RowOrderBy,
  RowQuery,
  SqliteQueryOptions,
} from '../../types/query.ts';
import { fareRules } from '../../schema/tables/gtfs-schedule/fare-rules.ts';
import { findRows } from '../sqlite-query.ts';

/**
 * Returns an array of all fare rules that match the query parameters.
 * @param query Column values to match, as single values or arrays
 * @param fields Columns to select, or every column when empty
 * @param orderBy Column and direction pairs to sort by
 * @param options Query options, including the database to read from
 * @returns Matching rows, containing only `fields` when it is not empty
 */
export function getFareRules<Fields extends keyof FareRule>(
  query: RowQuery<FareRule> = {},
  fields: readonly Fields[] = [],
  orderBy: RowOrderBy<FareRule> = [],
  options: SqliteQueryOptions = {},
) {
  return findRows<FareRule, Fields>(fareRules, query, fields, orderBy, options);
}
